import React, { Component } from "react";
import CircularJSON from "circular-json";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import NuxeoClient from "../../clients/NuxeoClient";
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";
import EventUtils from "../../utils/EventUtils";
import Loading from "../../components/loading/Loading";

import AddProductModal from "../ui/AddProductModal";
import Table from "../ui/Table";
import { FavMenu } from "../ui/FavMenu";
import SnackBar from "../ui/SnackBar";
import { JobLoadingModal } from "../ui/Modals";
import Licensee from "../inputs/Licensee";
import Contract from "../inputs/Contract";
import Territories from "../inputs/Territories";
import Property from "../inputs/Property";
import TierOfDistribution from "../inputs/TierOfDistribution";
import Retailer from "../inputs/Retailer";
import ConsumerTarget from "../inputs/ConsumerTarget";
import Season from "../inputs/Season";
import Date from "../inputs/Date";
import Text from "../inputs/Text";
import AssociatedJobs from "../inputs/AssociatedJobs";
import LineSheet from "../inputs/LineSheet";

import "../../css/submissionFields.css";
import { GAPageView } from "../..";
import ReactGA from "react-ga";

import { I18nContext } from "../../I18nProvider";

export class ProductSubmissionFields extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    //Define the component state
    this.state = {
      isSoldInPackage: false,
      isSoldInSet: false,
      isDigitalContent: false,
      isPlush: false,
      areFilesUploading: false,
      areSupportingFilesUploading: false,
      areLineSheetFilesUploading: false,
      isJobInfoLoading: false,
      isSubmitting: false,
      requiredFields: [
        "licensee",
        "contract",
        "property",
        "territories",
        "tierOfDistribution",
        "retailer",
        "consumerTarget",
        "modalSubmitData",
      ],
      modalrequiredFields: [
        "licenseeRef",
        "productDetail",
        "assetFileName",
        "characters",
        "files",
      ],

      licensee: null,
      licenseeID: null,
      licenseePath: null,
      licenseeCode: null,
      contract: "",
      contractID: null,
      territories: [],
      territoriesID: [],
      property: "",
      propertyID: null,
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      packageType: [],
      season: "",
      onShelfDate: null,
      productTitle: "",
      additionalNotes: "",
      associatedJobs: [],
      associatedJobsID: [],
      licenseeRef: "",
      lineSheetRef: "",
      retailerSKU: "",
      UPC: "",
      productDetail: null,
      productDetailID: null,
      assetFileName: [],
      assetFileID: null,
      originalAssetsUID: [],
      originalAssetsParentRef: [],
      characters: [],
      charactersID: [],
      text: "",
      name: [],
      originalSeason: "",
      originalAssetSeasonID: [],
      pricePointUSD: "",
      isFavorite: false,
      favoriteName: null,

      //dropzone state variables
      files: [],
      supportingFiles: [],
      lineSheetFiles: null,
      filesBatch: null,
      supportingFilesBatch: [],
      lineSheetFilesBatch: [],

      //data-fetching state variables
      fetchedLicensees: [],
      fetchedProperty: [],
      fetchedAssetFileNames: [],
      fetchedAssetFileCharacters: [],

      //modal variables
      modalSubmitData: [],
      editData: null,
      editIndex: null,
      modalOpened: false,
      resetModal: true,
      editModal: false,

      //snackbar
      openSnackMsg: false,
      snackBarMsg: "Sample Msg",
    };
    this.docPrefix = "prd";
    this.docType = "SubmissionProduct";
    this.document = null;

    this.handleRemoveFile = this.handleRemoveFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitModal = this.handleSubmitModal.bind(this);
    this.setJobInfo = this.setJobInfo.bind(this);
  }

  async componentDidMount() {
    await this._createEmptyDoc();
    GAPageView("Product Submission Form");
  }

  setJobInfo(jobInfo) {
    this.setState({ isJobInfoLoading: true });
    this.clearValues();

    this.setState({ contractID: jobInfo["submission:contract"] });
    this._getInfoById(jobInfo["submission:contract"]).then((res) =>
      this.setState({ contract: res.title }, () =>
        this._checkFieldChange("contract")
      )
    );

    this.setState({ territoriesID: jobInfo["submission:territories"] });
    jobInfo["submission:territories"].forEach((territory, index) => {
      this._getInfoById(territory).then((response) => {
        let territories = [...this.state.territories];
        territories.push(response.title);
        this.setState({ territories });
      });
    });

    this.setState({ propertyID: jobInfo["submission:property"] });
    this._getInfoById(jobInfo["submission:property"]).then((response) => {
      this.setState({ property: response.title }, () =>
        this._checkFieldChange("property")
      );
    });

    this.setState({ associatedJobsID: jobInfo["submission:associatedJobs"] });
    jobInfo["submission:associatedJobs"].forEach((id) => {
      this._getInfoById(id).then((response) => {
        let associatedJobs = [...this.state.associatedJobs];
        associatedJobs.push(response.title);
        this.setState({ associatedJobs });
      });
    });

    let productsArray = jobInfo[this.docPrefix + "_submission:product"];
    let modalSubmitData = [];
    for (var i = 0; i < productsArray.length; i++) {
      modalSubmitData[i] = this.getModalSubmitData();
    }
    productsArray.forEach((product, index) => {
      product[this.docPrefix + "_originalAssets"].forEach((asset) => {
        this._getInfoById(asset, index).then((response) => {
          var assetsArray = [...modalSubmitData[response.index].assetFileName];
          assetsArray.push(response.title);
          modalSubmitData[response.index].assetFileName = assetsArray;
        });
      });

      if (product[this.docPrefix + "_originalAssetsSeason"]) {
        product[this.docPrefix + "_originalAssetsSeason"].forEach((asset) => {
          this._getInfoById(asset, index).then((response) => {
            var assetsArray = [
              ...modalSubmitData[response.index].originalAssetsSeason,
            ];
            assetsArray.push(response.title);
            modalSubmitData[response.index].originalAssetsSeason = assetsArray;
          });
        });
      }

      product[this.docPrefix + "_characters"].forEach((character) => {
        this._getInfoById(character, index).then((response) => {
          var charactersArray = [...modalSubmitData[response.index].characters];
          charactersArray.push(response.title);
          modalSubmitData[response.index].characters = charactersArray;
        });
      });
      modalSubmitData[index].charactersID =
        product[this.docPrefix + "_characters"];

      modalSubmitData[index].productDetailID =
        product[this.docPrefix + "_productDetail"];
      this._getInfoById(product[this.docPrefix + "_productDetail"], index).then(
        (response) =>
          (modalSubmitData[response.index].productDetail = response.title)
      );

      modalSubmitData[index].licenseeRef = product[
        this.docPrefix + "_internalRefId"
      ]
        ? product[this.docPrefix + "_internalRefId"]
        : "";
      modalSubmitData[index].text_verbiage = product[
        this.docPrefix + "_assetTextVerbiage"
      ]
        ? product[this.docPrefix + "_assetTextVerbiage"]
        : "";
      modalSubmitData[index].originalSeason = product[
        this.docPrefix + "_originalAssetsSeasonLabel"
      ]
        ? product[this.docPrefix + "_originalAssetsSeasonLabel"]
        : "";
      modalSubmitData[index].originalAssetSeasonID = product[
        this.docPrefix + "_originalAssetSeason"
      ]
        ? product[this.docPrefix + "_originalAssetSeason"]
        : null;
      modalSubmitData[index].retailerSKU = product[this.docPrefix + "_sku"]
        ? product[this.docPrefix + "_sku"]
        : "";
      modalSubmitData[index].UPC = product[this.docPrefix + "_upc"]
        ? product[this.docPrefix + "_upc"]
        : "";
      modalSubmitData[index].onShelfDate =
        product[this.docPrefix + "_inMarketDate"];
      modalSubmitData[index].originalAssetsUID =
        product[this.docPrefix + "_originalAssets"];
      modalSubmitData[index].isSoldInPackage =
        product[this.docPrefix + "_isSoldInPackage"];
      modalSubmitData[index].isSoldInSet =
        product[this.docPrefix + "_isSoldInSet"];
      modalSubmitData[index].isDigitalContent =
        product[this.docPrefix + "_isDigitalContent"];
      modalSubmitData[index].isPlush = product[this.docPrefix + "_isPlush"];
      modalSubmitData[index].pricePointUSD =
        product[this.docPrefix + "_pricePoint"];
    });

    this.setState({
      tierOfDistribution: jobInfo["submission:tierOfDistribution"],
      retailer: jobInfo["submission:retailer"],
      consumerTarget: jobInfo["submission:consumerTarget"],
      onShelfDate: jobInfo["submission:inMarketDate"],
      productTitle: jobInfo["dc:description"] ? jobInfo["dc:description"] : "",
      lineSheetRef: jobInfo["submission:internalRefId"]
        ? jobInfo["submission:internalRefId"]
        : "",
      additionalNotes: jobInfo["submission:notes"]
        ? jobInfo["submission:notes"]
        : "",
      season: jobInfo["submission:inMarketSeason"],
    });

    let packageType = [...this.state.packageType];
    packageType.push(jobInfo[this.docPrefix + "_submission:packageTypePkg"]);
    this.setState({ packageType });

    setTimeout(() => {
      this.setState({
        modalSubmitData,
        isJobInfoLoading: false,
      });
    }, 5000);
  }

  async _getInfoById(id, index = null) {
    var response;

    await NuxeoClient.instance()
      .getJobInfo(id)
      .then((res) => {
        response = res;
      });
    response.index = index;

    return response;
  }

  async _createEmptyDoc() {
    await NuxeoClient.instance()
      .fetchDocument(this.docType)
      .then((response) => {
        this.document = response;
      });
  }

  onCloseModal = () => {
    this.setState({
      modalOpened: false,
      resetModal: true,
      editModal: false,
      areFilesUploading: false,
      areSupportingFilesUploading: false,
    });
  };

  handleChange = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => this._checkFieldChange(name)
    );
  };

  clearValues() {
    this.setState({
      contract: "",
      territories: [],
      property: "",
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      packageType: [],
      season: "",
      onShelfDate: null,
      productTitle: "",
      additionalNotes: "",
      associatedJobs: [],
      lineSheetFiles: "",
      lineSheetFilesBatch: [],
      lineSheetRef: "",
      modalSubmitData: [],
    });
  }

  _checkFieldChange(name) {
    if (name === "licenseeCode") {
      this.clearValues();
    }

    if (name === "contractID") {
      if (!this.state.isJobInfoLoading) {
        this.setState({
          territories: [],
          property: "",
          productDetail: null,
          productDetailID: null,
          originalAssetsUID: [],
          originalAssetsParentRef: [],
          characters: [],
          charactersID: [],
        });
      }
    }

    if (name === "propertyID") {
      this.setState({
        originalAssetsUID: [],
        originalAssetsParentRef: [],
        characters: [],
        charactersID: [],
        fetchedAssetFileCharacters: [],
      });
    }

    if (name === "licenseeRef")
      this.setState({
        retailerSKU: this.state.licenseeRef,
      });
  }

  handleCheckboxChange = (name) => {
    let value = !this.state[name];
    this.setState({
      [name]: value,
    });
  };

  handleRemoveFile(name, file) {
    if (name === "supportingFiles") {
      let supportingFilesBatch = [...this.state.supportingFilesBatch];
      supportingFilesBatch = supportingFilesBatch.filter(
        (data) => data !== file
      );
      this.setState({ supportingFilesBatch });
    } else if (name === "lineSheetFiles") {
      this.setState({
        [name]: [],
        [name + "Batch"]: null,
      });
    } else {
      this.setState({
        files: [],
        filesBatch: null,
      });
    }
  }

  //Saving files to state for further use and closing Modal.
  async handleSave(name, newFiles, isLast = false) {
    if (name === "files") {
      this.setState({ areFilesUploading: true });
    }
    if (name === "supportingFiles") {
      this.setState({ areSupportingFilesUploading: true });
    }
    if (name === "lineSheetFiles") {
      this.setState({ areLineSheetFilesUploading: true });
    }

    await NuxeoClient.instance()
      .getBatchID()
      .then((response) => {
        NuxeoClient.instance()
          .uploadFiles(newFiles, response.batchId)
          .then((response) => {
            NuxeoClient.instance()
              .getFileInfo(response.batchId)
              .then((response) => {
                if (response.code !== "201") {
                  if (name === "files") {
                    this.setState({ areFilesUploading: false });
                  }
                  if (name === "supportingFiles" && isLast === true) {
                    this.setState({ areSupportingFilesUploading: false });
                  }
                  if (name === "lineSheetFiles") {
                    this.setState({ areLineSheetFilesUploading: false });
                  }
                }
                let fileObj = {
                  name: response.fileEntries[0].name,
                  "upload-batch": response.batchId,
                  "upload-fileId": "0",
                };
                if (name === "supportingFiles") {
                  let supportingFilesBatch = [
                    ...this.state.supportingFilesBatch,
                  ];
                  supportingFilesBatch.push(fileObj);
                  this.setState({ supportingFilesBatch });
                } else if (name === "files") {
                  this.setState({ filesBatch: fileObj });
                } else if (name === "lineSheetFiles") {
                  var lsArray = [];
                  lsArray.push(fileObj);
                  this.setState({ lineSheetFilesBatch: lsArray });
                }
              });
          });
      });
    this.setState({
      [name]: newFiles,
      [name + "Open"]: false,
    });
  }

  getModalSubmitData = () => {
    var data = {
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      productDetailID: this.state.productDetailID,
      originalSeason: this.state.originalSeason,
      originalAssetSeasonID: this.state.originalAssetSeasonID,
      assetFileName: this.state.assetFileName,
      originalAssetsParentRef: this.state.originalAssetsParentRef,
      originalAssetsUID: this.state.originalAssetsUID,
      retailerSKU: this.state.retailerSKU,
      UPC: this.state.UPC,
      pricePointUSD: this.state.pricePointUSD,
      isSoldInPackage: this.state.isSoldInPackage,
      isSoldInSet: this.state.isSoldInSet,
      isPlush: this.state.isPlush,
      isDigitalContent: this.state.isDigitalContent,
      onShelfDate: this.state.onShelfDate,
      productFile: this.state.filesBatch,
      characters: this.state.characters,
      charactersID: this.state.charactersID,
      text_verbiage: this.state.text,
      filesBatch: this.state.filesBatch,
      files: this.state.files,
      supportingFilesBatch: this.state.supportingFilesBatch,
    };
    return data;
  };

  handleSubmitModal = () => {
    var regex = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/;

    if (this.state.pricePointUSD !== null && this.state.pricePointUSD !== "") {
      if (this.state.pricePointUSD.toString().match(regex) === null) {
        this.setState({
          openSnackMsg: true,
          snackBarMsg: "Price point should be a numeric value",
        });
        return false;
      }
    }

    if (this.state.UPC !== null && this.state.UPC !== "") {
      var upc = this.state.UPC;
      var upcArray = upc.replace(/, +/g, ",").split(",");

      const invalidupc = [];
      const exp = /^[0-9]+$/;
      const dupUpc = [];
      for (const upcItem of upcArray) {
        if (dupUpc.indexOf(upcItem) === -1) {
          dupUpc.push(upcItem);
        }
      }

      if (upcArray.length === dupUpc.length) {
        for (const upcItem of upcArray) {
          const strUpc = upcItem.toString();
          if (strUpc.length !== 12 || upcItem.match(exp) === null) {
            this.setState({
              openSnackMsg: true,
              snackBarMsg: `${upcItem} UPC should contain 12 numeric digits`,
            });
            return false;
          }

          const originalCheck = +strUpc.split("").pop();
          let even =
            +strUpc.charAt(0) * 3 +
            +strUpc.charAt(2) * 3 +
            +strUpc.charAt(4) * 3 +
            +strUpc.charAt(6) * 3 +
            +strUpc.charAt(8) * 3 +
            +strUpc.charAt(10) * 3;

          let odd =
            +strUpc.charAt(1) +
            +strUpc.charAt(3) +
            +strUpc.charAt(5) +
            +strUpc.charAt(7) +
            +strUpc.charAt(9);
          const total = even + odd;

          const checksum = total % 10;
          const checksumModulo = checksum === 0 ? 0 : 10 - checksum;

          if (checksumModulo !== originalCheck) {
            invalidupc.push(upcItem);
          }
        }
        if (invalidupc.length !== 0) {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: `${invalidupc} upc is not valid`,
          });
          return false;
        }
      } else {
        this.setState({
          openSnackMsg: true,
          snackBarMsg: `UPC should be unique`,
        });
        return false;
      }
    }

    let modalSubmitData = [...this.state.modalSubmitData];

    if (this.state.editModal) {
      modalSubmitData = modalSubmitData.filter(
        (data) => data !== this.state.editData
      );
    }

    modalSubmitData.push(this.getModalSubmitData());

    this.setState({
      modalSubmitData,
      modalOpened: false,
      editModal: false,
      resetModal: true,
    });
  };

  handleCancel() {
    window.location.href = "/#!/home";
  }

  checkFiles() {
    var designMissing = false;

    this.state.modalSubmitData.forEach((data) => {
      if (data.filesBatch === null || data.filesBatch === "") {
        designMissing = true;
      }
    });

    if (designMissing) {
      this.setState({
        openSnackMsg: true,
        snackBarMsg: `Please, use pencil icon to upload your design from the Add product`,
      });
      return false;
    } else return true;
  }

  async handleSubmit() {
    if (!this.checkFiles()) {
      return false;
    }

    window.scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    this.setState({ isSubmitting: true });

    let productsArray = [];

    this.state.modalSubmitData.forEach((item) => {
      let files = [];

      files.push(item.filesBatch);

      item.supportingFilesBatch.map((file) => files.push(file));

      let product = {
        property: this.state.propertyID,
        propertyName: [this.state.property],
        contractId: this.state.contractID,
        contractProps: this.state.propertyID,
        prd_assetTextVerbiage: item.text_verbiage,
        prd_pricePoint: item.pricePointUSD,
        prd_characters: item.charactersID,
        prd_charactersLabel: item.characters,
        prd_upc: item.UPC === "" ? null : item.UPC,
        prd_sku: item.retailerSKU === "" ? null : item.retailerSKU,
        prd_inMarketDate: this.state.onShelfDate
          ? ArrayUtils.convertToISO(this.state.onShelfDate)
          : "",
        prd_internalRefId: item.licenseeRef === "" ? null : item.licenseeRef,
        prd_originalAssets: item.originalAssetsUID,
        prd_originalAssetsLabel: item.assetFileName,
        prd_originalAssetsParentRef: item.originalAssetsParentRef,
        prd_productDetail: item.productDetailID,
        prd_originalAssetsSeason: item.originalAssetSeasonID,
        prd_originalAssetsSeasonLabel:
          item.originalSeason !== "" ? [item.originalSeason] : [],
        prd_productDetailLabel: [item.productDetail],
        prd_files: files,
        prd_isSoldInPackage: item.isSoldInPackage,
        prd_isSoldInSet: item.isSoldInSet,
        prd_isDigitalContent: item.isDigitalContent,
        prd_isPlush: item.isPlush,
      };
      productsArray.push(product);
    });

    this.document.properties["dc:description"] =
      this.state.productTitle === "" ? null : this.state.productTitle;
    this.document.properties["dc:title"] = this.state.contract;
    this.document.properties[this.docPrefix + "_submission:product"] =
      productsArray;
    //this.document.properties['prd_submission:packageTypePkg'] = this.state.packageType
    this.document.properties["prd_submission:linesheet"] =
      this.state.lineSheetFilesBatch.length > 0
        ? this.state.lineSheetFilesBatch[0]
        : null;
    this.document.properties["submission:associatedJobs"] =
      this.state.associatedJobsID;
    this.document.properties["submission:consumerTarget"] =
      this.state.consumerTarget;
    this.document.properties["submission:inMarketSeason"] =
      this.state.season !== "" ? this.state.season : null;
    this.document.properties["submission:contract"] = this.state.contractID;
    this.document.properties["submission:inMarketDate"] = this.state.onShelfDate
      ? ArrayUtils.convertToISO(this.state.onShelfDate)
      : "";
    this.document.properties["submission:internalRefId"] =
      this.state.lineSheetRef === "" ? null : this.state.lineSheetRef;
    this.document.properties["submission:licensee"] = this.state.licenseeID;
    this.document.properties["submission:notes"] =
      this.state.additionalNotes === "" ? null : this.state.additionalNotes;
    this.document.properties["submission:property"] = this.state.propertyID;
    this.document.properties["submission:propertyName"] = this.state.property;
    this.document.properties["submission:retailer"] = this.state.retailer;
    this.document.properties["submission:territories"] =
      this.state.territoriesID;
    this.document.properties["submission:tierOfDistribution"] =
      this.state.tierOfDistribution;
    this.document.properties["submission:isFavorite"] = this.state.isFavorite;
    this.document.properties["submission:favoriteName"] =
      this.state.favoriteName;

    let products =
      this.document.properties[this.docPrefix + "_submission:product"];
    let productsOld = JSON.parse(JSON.stringify(products));

    this.document.name =
      this.document.name ||
      StringUtils._sanitizeName(this.document.properties["dc:title"]);
    let documentEnrichmentParams = {
      documentProperties: JSON.stringify(this.document.properties),
      docPrefix: this.docPrefix,
      propertyName: this.document.properties["submission:propertyName"],
      parentRef: this.state.licenseeID,
    };
    this.docPath =
      "/default-domain/workspaces/Submission/" + this.state.licensee;
    NuxeoClient.instance()
      .documentEnrichment(documentEnrichmentParams)
      .then((res) => {
        this.document.properties = res;
        this.document = JSON.parse(CircularJSON.stringify(this.document));
        NuxeoClient.instance()
          .submitDocument(this.docPath, this.document)
          .then((responseDoc) => {
            const jobId =
              this.document.properties["submission:workfrontProjectId"];
            ReactGA.event({
              category: "Form",
              action: "Form Submit",
              transport: "beacon",
              label: `Product Submitted - ${this.state.property}`,
            });
            window.history.pushState({}, null, `/submit/product?${jobId}`);
            EventUtils.raiseEvent("success", { jobId: jobId }, this.props);
          });
      })
      .catch((error) => {
        this.document.properties[this.docPrefix + "_submission:product"] =
          productsOld;
        console.log("Error in DocumentEnrichment parsing: " + error);
        ReactGA.event({
          category: "Form",
          action: "Form Submit Error",
          transport: "beacon",
          label: `Product Form Error - ${error}`,
        });
        alert("Failed to submit job.");

        //submit progress indicator show
        this.setState({ isSubmitting: false });
      });
  }

  //the purpose of this method is to edit a product in the product's table,
  editRow = (index) => {
    var data = this.state.modalSubmitData[index];

    this.setState({
      editData: data,
      editIndex: index,
      licenseeRef: data.licenseeRef,
      productDetail: data.productDetail,
      productDetailID: data.productDetailID,
      assetFileName: data.assetFileName,
      originalAssetsUID: data.originalAssetsUID,
      originalAssetsParentRef: data.originalAssetsParentRef,
      characters: data.characters,
      originalSeason: data.originalSeason,
      originalAssetSeasonID: data.originalAssetSeasonID,
      retailerSKU: data.retailerSKU,
      filesBatch: data.filesBatch,
      files: data.files,
      supportingFilesBatch: data.supportingFilesBatch,
      isDigitalContent: data.isDigitalContent,
      isPlush: data.isPlush,
      isSoldInPackage: data.isSoldInPackage,
      isSoldInSet: data.isSoldInSet,
      UPC: data.UPC,
      text: data.text_verbiage,
      onShelfDate: data.onShelfDate,
      pricePointUSD: data.pricePointUSD,
      modalOpened: true,
      resetModal: false,
      editModal: true,
    });
  };
  //linesheet table
  deleteRow = (index) => {
    var data = this.state.modalSubmitData[index];
    const modalSubmitData = this.state.modalSubmitData.filter(
      (item) => item.licenseeRef !== data.licenseeRef
    );

    this.setState({
      modalSubmitData: modalSubmitData,
    });
  };

  checkRequiredFields = () => {
    for (var item of this.state.requiredFields) {
      if (
        this.state[item] === null ||
        this.state[item] === "" ||
        (typeof this.state[item] === "object" && this.state[item].length === 0)
      ) {
        if (item === "files") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Upload any one design file is required to proceed",
          });
        } else if (item === "modalSubmitData") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Add at least one product to proceed",
          });
        } else {
          item = item.replace(/([A-Z])/g, " $1").trim();
          item = item[0].toUpperCase() + item.slice(1);
          this.setState({
            openSnackMsg: true,
            snackBarMsg: `${item} is required to proceed`,
          });
        }
        return false;
      }
    }
  };

  render() {
    const appText = this.context;
    return (
      <div className="marketing-form-container">
        <Fade in={true} timeout={500}>
          <Grid
            container={true}
            direction="column"
            spacing={4}
            alignItems="stretch"
            className="form-wrapper"
          >
            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <div id="header-with-fav">
                <h5 className="form-heading">{appText.T7}</h5>
                <FavMenu
                  setJobInfo={this.setJobInfo}
                  licensee={this.state.licensee}
                  licenseePath={this.state.licenseePath}
                  docType={this.docType}
                  user={this.props.user}
                  handleChange={this.handleChange}
                />
              </div>
            </Grid>

            <JobLoadingModal isJobInfoLoading={this.state.isJobInfoLoading} />

            <Licensee
              handleChange={this.handleChange}
              value={this.state.licensee}
              fetchedData={this.state.fetchedLicensees}
            />

            <Contract
              value={this.state.contract}
              handleChange={this.handleChange}
              licenseeCode={this.state.licenseeCode}
            />

            {this.state.contract ? (
              <Territories
                value={this.state.territories}
                id={this.state.territoriesID}
                contractID={this.state.contractID}
                handleChange={this.handleChange}
              />
            ) : null}

            {this.state.contract ? (
              <Property
                value={this.state.property}
                fetchedData={this.state.fetchedProperty}
                contractID={this.state.contractID}
                handleChange={this.handleChange}
              />
            ) : null}

            <TierOfDistribution
              handleChange={this.handleChange}
              value={this.state.tierOfDistribution}
            />

            <Retailer
              handleChange={this.handleChange}
              value={this.state.retailer}
            />

            <ConsumerTarget
              handleChange={this.handleChange}
              value={this.state.consumerTarget}
            />

            <Season handleChange={this.handleChange} id={this.state.season} />

            <Date
              // title={"On-shelf Date"}
              title={appText.T59}
              field={"onShelfDate"}
              isRequired={false}
              message={
                // "Please enter the date the product being marketed will enter the markets"
                appText.T122
              }
              handleChange={this.handleChange}
              value={this.state.onShelfDate}
            />

            <Text
              // inputName="Project Description"
              inputName={appText.T62}
              value={this.state.productTitle}
              field="productTitle"
              // message={CommonContants.PROJECT_DESCRIPTION_MESSAGE}
              message={appText.T123}
              handleChange={this.handleChange}
            />

            <Text
              // inputName="Linesheet Reference #"
              inputName={appText.T63}
              value={this.state.lineSheetRef}
              field="lineSheetRef"
              // message={CommonContants.LS_REF_MESSSAGE}
              message={appText.T124}
              handleChange={this.handleChange}
            />

            <Text
              // inputName="Notes for BA Representative"
              inputName={appText.T64}
              value={this.state.additionalNotes}
              field="additionalNotes"
              // message={CommonContants.NOTES_MESSAGE}
              message={appText.T125}
              handleChange={this.handleChange}
              // helperText="If applicable, please provide any additional context/notes about this submission for our review"
              helperText={appText.T65}
            />
            <br />

            <AssociatedJobs
              handleChange={this.handleChange}
              value={this.state.associatedJobs}
              id={this.state.associatedJobsID}
            />

            <LineSheet
              isUploading={this.state.areLineSheetFilesUploading}
              handleSave={this.handleSave}
              handleRemoveFile={this.handleRemoveFile}
              lineSheetFilesBatch={this.state.lineSheetFilesBatch}
            />

            <Grid item={true} xs={12}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="outlined"
                  // disabled={this.state.property ? false : true}
                  onClick={() => this.handleChange("modalOpened", true)}
                  style={{ width: "100%", fontSize: "1rem" }}
                >
                  {/* +Add Product */}
                  {appText.T76}
                </Button>
              </div>

              <div id="header-legal-line">
                <h8 className="legal-line">
                  {/* Please ensure legal line is visible on submission. */}
                  {appText.T77}
                </h8>
              </div>

              {this.state.modalOpened === true ? (
                <AddProductModal
                  resetData={this.state.resetModal}
                  edit={this.state.editModal}
                  type={"product"}
                  data={this.state}
                  handleChange={this.handleChange}
                  handelChangeAutocomplete={this.handleChange}
                  handleMultipleChange={this.handleChange}
                  handleCheckboxChange={this.handleCheckboxChange}
                  handleSave={this.handleSave}
                  handleRemoveFile={this.handleRemoveFile}
                  onCloseModal={this.onCloseModal}
                  handleSubmitModal={this.handleSubmitModal}
                />
              ) : (
                <div></div>
              )}
            </Grid>

            <Table
              modalSubmitData={this.state.modalSubmitData}
              editRow={this.editRow}
              deleteRow={this.deleteRow}
            />

            <Grid item={true} xs={12}>
              {this.state.licensee &&
              this.state.contract &&
              this.state.property &&
              this.state.territories.length > 0 &&
              this.state.tierOfDistribution.length > 0 &&
              this.state.retailer.length > 0 &&
              this.state.consumerTarget.length > 0 &&
              this.state.modalSubmitData.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleSubmit}
                    type="submit"
                    value="Submit"
                  >
                    {appText.T113 /* Submit */}
                  </Button>{" "}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <span
                    onClick={this.checkRequiredFields}
                    style={{
                      display: "inline-block",
                      width: "auto",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn"
                      disabled
                      onClick={this.handleSubmit}
                      type="submit"
                      value="Submit"
                    >
                      {appText.T113 /* Submit */}
                    </Button>
                  </span>
                </div>
              )}
            </Grid>

            <Loading hidden={!this.state.isSubmitting}></Loading>
            <SnackBar
              isOpen={this.state.openSnackMsg}
              snackBarMsg={this.state.snackBarMsg}
              handleChange={this.handleChange}
            />
          </Grid>
        </Fade>
      </div>
    );
  }
}

export default ProductSubmissionFields;
